import axios from 'axios'
import { hideLoading } from '@/assets/js/android'

const host = window.location.host

const ENV = process.env.NODE_ENV

const service = axios.create({
  baseURL: ENV === 'development' ? '/api' : `https://${host}`
})
service.defaults.timeout = 60000
// 请求发出前处理
service.interceptors.request.use((config) => {
  config.headers = {
    token: localStorage.getItem('token')
  }
  return config
})

// 响应取得后处理
service.interceptors.response.use(
  function (response) {
    const code = response.data.status.code
    if (code === 0) {
      return response.data.data !== undefined ? response.data : { data: {} }
    } else {
      hideLoading()
      // 返回data，需要在 catch 里自己处理 code 和 message
      return Promise.reject(response.data)
    }
  },
  function (error) {
    hideLoading()
    return Promise.reject({ status: 'err' })
  }
)

export default service
